import { Events } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AreaLocalProvider } from '../area-local/area-local';
import { BrComService } from '../../service/BrComService';
import { EmpresaLocalProvider } from '../empresa-local/empresa-local';
import { HttpServidor } from '../shared/abstract/http-servidor';
import { Mensagem, OrigemMensagem, TipoMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../mensagem/mensagem'

@Injectable()
export class AreaProvider extends HttpServidor {

  constructor(http: HttpClient, 
    private areaLocalProvider: AreaLocalProvider, 
    private mensagemProvider: MensagemProvider,
    private empresaLocal: EmpresaLocalProvider,
    private brComService: BrComService,
    private events: Events) {
    super(http);
  }

  public enviarMensagemAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesAdminArea', form);
  }

  public enviarMensagemUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesUsuarioArea', form);
  }

  public enviarMensagemResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesResposta', form);
  }

  public enviarMensagemImagemAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemAdminArea', form);
  }

  public enviarMensagemImagemUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemUsuarioArea', form);
  }

  public enviarMensagemImagemResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemResposta', form);
  }

  public enviarMensagemArquivoAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoAdminArea', form);
  }

  public enviarMensagemArquivoUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoUsuarioArea', form);
  }

  public enviarMensagemArquivoResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoResposta', form);
  }

  public notificarMensagensLidas(idUsuario: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(idUsuario));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaLidas', form);
  }

  public notificarMensagensRecebidas(idUsuario: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(idUsuario));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaRecebidas', form);
  }

  public processarMensagemSimples(payload: any): void {
    const mensagem = this.mensagemProvider.criarMensagemSimples(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemImagem(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemImagem(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemArquivo(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemArquivo(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemResposta(payload: any): void {
    const mensagem = this.mensagemProvider.criarMensagemResposta(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemLink(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemLink(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemFacebook(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemFacebook(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemHTML(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemHTML(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  private adicionarNovaMensagemArea(mensagem: Mensagem, idUsuario: number) {
    mensagem.origem = OrigemMensagem.ESQUERDA;
    this.areaLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}`);
    this.areaLocalProvider.marcarMensagemRecebida(mensagem.idArea, mensagem.idEnvio);
    this.notificarMensagensRecebidas(idUsuario, this.brComService.getIdDevice(), mensagem.idArea).subscribe();
  }

  private adicionarNovaMensagemEnviadaDeOutroDevice(mensagem: Mensagem): void {
    mensagem.origem = OrigemMensagem.DIREITA;
    mensagem.podeSerRespondida = false;
    this.areaLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}`);
  }

  private adicionarNovaMensagem(mensagem: Mensagem) {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    const administradores = this.areaLocalProvider.getArea(mensagem.idArea).idAdministradores;
    const isAdmin = administradores.indexOf(idUsuario) > -1;
    if (mensagem.idUsuarioOrigem === idUsuario) {
      this.adicionarNovaMensagemEnviadaDeOutroDevice(mensagem);
    } else if (administradores.indexOf(idUsuario) > -1 && administradores.indexOf(mensagem.idUsuarioOrigem) > -1) {
      this.adicionarNovaMensagemEnviadaDeOutroDevice(mensagem);
    } else {
      if (window.parent) {
        // envia mensagem para o sistema
        window.parent.postMessage(mensagem, "*");
      }
      this.adicionarNovaMensagemArea(mensagem, idUsuario);
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/area/area.ts